import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { LicenseInfo } from '@mui/x-license';
import * as Sentry from '@sentry/react';
import CssBaseline from '@mui/material/CssBaseline';

import { keycloakConfig } from 'config';
import { AuthProvider } from 'react-oidc-context';
import App from './App';
import { User } from 'oidc-client-ts';

LicenseInfo.setLicenseKey(`${import.meta.env.REACT_APP_MUI_PRO_LICENSE}`);

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement!);

/**
 * Removes the payload from the URL upon successful login.
 * Otherwise, if you refresh the page and the payload are still there, signInSilent
 * which handles renewing the token, won't work.
 */
const onSigninCallback = (_user: User | undefined): void => {
  window.history.replaceState({}, document.title, window.location.pathname);
};

Sentry.init({
  dsn: `${import.meta.env.REACT_APP_SENTRY_DSN}`,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  release: `${process.env.SENTRY_RELEASE}`,
});

root.render(
  <React.StrictMode>
    <CssBaseline />
    <AuthProvider {...keycloakConfig} onSigninCallback={onSigninCallback}>
      <App />
    </AuthProvider>
  </React.StrictMode>,
);
